import type { TourStepData } from './types';

export const blogManagerTourSteps: TourStepData[] = [
  {
    target: '[data-tour="blog-manager-header"]',
    title: 'Blog Manager',
    content:
      'Le Blog Manager (Gestionnaire de blog) permet de creer et gerer des articles SEO (Referencement naturel) avec generation IA et auto-traduction.',
    placement: 'bottom',
    glossaryTerm: 'blog-manager',
  },
  {
    target: '.grid.grid-cols-1.sm\\:grid-cols-3',
    title: 'Statistiques articles',
    content:
      'Suivez le nombre total d\'articles, les articles publies et les brouillons en attente de publication.',
    placement: 'bottom',
  },
  {
    target: '.fc-card',
    title: 'Tableau des articles',
    content:
      'Gerez vos articles : titre, slug (Identifiant URL), statut, date de publication. Cliquez pour ouvrir l\'editeur complet avec SEO et image a la une.',
    placement: 'top',
    glossaryTerm: 'slug',
  },
];
